document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('#MobileMenu');
  if (toggle) {
    const setMenuOpen = (open) => {
      document.body.classList.toggle('menu-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (drawer) drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    };

    toggle.addEventListener('click', () => {
      setMenuOpen(!document.body.classList.contains('menu-open'));
    });

    drawer?.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setMenuOpen(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && document.body.classList.contains('menu-open')) {
        setMenuOpen(false);
        toggle.focus();
      }
    });
  }

  const formStatus = document.querySelector('.form-status, .footer-newsletter__status');
  if (formStatus) formStatus.focus();

  document.querySelectorAll('[data-localization-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  document.querySelectorAll('[data-countdown]').forEach((countdown) => {
    const target = Date.parse(countdown.dataset.countdownTarget);
    const completeMessage = countdown.parentElement.querySelector('[data-countdown-complete]');
    const values = {
      days: countdown.querySelector('[data-countdown-days]'),
      hours: countdown.querySelector('[data-countdown-hours]'),
      minutes: countdown.querySelector('[data-countdown-minutes]'),
      seconds: countdown.querySelector('[data-countdown-seconds]')
    };

    if (Number.isNaN(target)) {
      countdown.hidden = true;
      return;
    }

    let intervalId;
    const renderCountdown = () => {
      const remaining = Math.max(0, target - Date.now());
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      values.days.textContent = String(days).padStart(2, '0');
      values.hours.textContent = String(hours).padStart(2, '0');
      values.minutes.textContent = String(minutes).padStart(2, '0');
      values.seconds.textContent = String(seconds).padStart(2, '0');

      if (remaining === 0) {
        clearInterval(intervalId);
        countdown.hidden = true;
        if (completeMessage) completeMessage.hidden = false;
      }
    };

    renderCountdown();
    if (target > Date.now()) intervalId = window.setInterval(renderCountdown, 1000);
  });

  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const delta = button.dataset.action === 'plus' ? 1 : -1;
        input.value = Math.max(1, Number(input.value || 1) + delta);
      });
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('select[name="id"]');
    const radios = [...form.querySelectorAll('[data-option-radio]')];
    if (!select || !radios.length) return;

    const variants = JSON.parse(form.querySelector('[data-variants-json]').textContent);
    const updateVariant = () => {
      const values = [];
      const groups = [...new Set(radios.map(r => r.name))];
      groups.forEach(name => {
        const checked = form.querySelector(`input[name="${name}"]:checked`);
        if (checked) values.push(checked.value);
      });
      const match = variants.find(v => v.options.every((option, i) => option === values[i]));
      if (match) {
        select.value = match.id;
        const submit = form.querySelector('[type="submit"]');
        submit.disabled = !match.available;
        submit.textContent = match.available ? submit.dataset.availableText : submit.dataset.soldoutText;
      }
    };
    radios.forEach(r => r.addEventListener('change', updateVariant));
  });

  document.querySelectorAll('[data-patch-lab]').forEach((patchLab) => {
    const display = patchLab.querySelector('[data-patch-display]');
    const displayImage = patchLab.querySelector('[data-patch-display-image]');
    const name = patchLab.querySelector('[data-patch-name]');
    const screen = patchLab.querySelector('.lm-patch-console__screen');
    const wearablePatch = patchLab.querySelector('[data-wearable-patch]');
    const wearableText = patchLab.querySelector('[data-wearable-patch-text]');
    const wearableImage = patchLab.querySelector('[data-wearable-patch-image]');
    const wearableName = patchLab.querySelector('[data-wearable-patch-name]');
    const options = [...patchLab.querySelectorAll('[data-patch-option]')];

    options.forEach((option) => {
      option.addEventListener('click', () => {
        options.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });

        option.classList.add('is-active');
        option.setAttribute('aria-pressed', 'true');
        const patchImage = option.dataset.patchImage;
        if (display) {
          display.textContent = option.dataset.patchValue;
          display.hidden = Boolean(patchImage);
        }
        if (displayImage) {
          if (patchImage) {
            displayImage.src = patchImage;
            displayImage.hidden = false;
          } else {
            displayImage.removeAttribute('src');
            displayImage.hidden = true;
          }
        }
        if (name) name.textContent = option.dataset.patchName;
        if (screen) screen.style.setProperty('--patch-accent', option.dataset.patchAccent);
        if (wearableText) {
          wearableText.textContent = option.dataset.patchValue;
          wearableText.hidden = Boolean(patchImage);
        }
        if (wearableImage) {
          if (patchImage) {
            wearableImage.src = patchImage;
            wearableImage.hidden = false;
          } else {
            wearableImage.removeAttribute('src');
            wearableImage.hidden = true;
          }
        }
        if (wearableName) wearableName.textContent = option.dataset.patchName;
        if (wearablePatch) {
          wearablePatch.style.setProperty('--patch-accent', option.dataset.patchAccent);
          wearablePatch.classList.add('is-changing');
          window.setTimeout(() => wearablePatch.classList.remove('is-changing'), 180);
        }
      });
    });
  });

  const revealItems = [...document.querySelectorAll('[data-reveal]')];
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    revealItems.forEach((item) => revealObserver.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }
});
